/** Extrae vehicle_id de notas de custodia espejo (Transportes → persona). */
export function parseCustodyVehicleId(notes) {
  const m = String(notes || '').match(/\[custodia_vehiculo:(\d+)\]/);
  return m ? Number(m[1]) : 0;
}
